module.exports = __webpack_public_path__ + "img/실시간화상과외온스쿨.1faa8d91.png";